import { render } from "./IndexSg.vue?vue&type=template&id=5e00b358&scoped=true"
import script from "./IndexSg.vue?vue&type=script&lang=js"
export * from "./IndexSg.vue?vue&type=script&lang=js"

import "./IndexSg.vue?vue&type=style&index=0&id=5e00b358&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e00b358"]])

export default __exports__